import { protectedResources } from '../../authConfig';
import makeGetRequestAsync, { makePostRequestAsync } from '../Helpers/httpRequestHelpers';

export interface UserCompanyDto {
  companyId: number;
  registeredName: string | null;
  registrationNumber: string | null;
  isCurrentDefault: boolean;
}

const apiScopes = protectedResources.companyApi.scopes;
const baseUrl = protectedResources.companyApi.endpoint;

/*
 * Returns all companies the authenticated user is linked to.
 */
export async function getMyCompanies(): Promise<UserCompanyDto[]> {
  const result = await makeGetRequestAsync<UserCompanyDto[]>(
    apiScopes,
    `${baseUrl}/api/Company/CompanyUser/GetMyCompanies`
  );
  return result.data;
}

/*
 * Creates a blank company stub, attaches the authenticated user to it as their new default,
 * and returns the new company ID. Call before redirecting into the registration wizard.
 */
export async function startAdditionalCompanyRegistration(): Promise<number> {
  const result = await makePostRequestAsync<number, Record<string, never>>(
    apiScopes,
    `${baseUrl}/api/Company/CompanyUser/StartAdditionalCompanyRegistration`,
    {}
  );
  return result.data;
}
